<template>
    <div id="aboutus">
        <b-container fluid class="wrapper-aboutus">
            <b-row>
                <b-col md="10" lg="7">
                    <h3>{{ $t('aboutus.title') }}</h3>
                    <h4>{{ $t('aboutus.subtitle') }}</h4>
                </b-col>
                <b-col lg="12" class="wrapper-video">
                    <video muted playsinline autoplay loop>
                        <source src="../assets/loader-carrying-pallet-of-boxes-in-warehouse-2022-08-10-08-26-35-utc.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </b-col>
                <b-col class="centerv" lg="6">
                    <h4 class="mb-5">{{ $t('aboutus.subtitle2') }}</h4>
                    <p>{{ $t('aboutus.text') }}</p>
                </b-col>
                <b-col class="centerv" style="position: relative;" offset-lg="1" lg="5">
                    <img src="../assets/img_about2.png" class="img-fluid" alt="">
                    <span class="highlight">02 <div class="after"></div></span>
                </b-col>
            </b-row>
        </b-container>
        
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
#aboutus{
    padding: 100px 35px 0 35px;
}
.wrapper-aboutus{
    background: #F1EBE3;
    border-radius: 50px;
    padding: 115px 82px;
}
.wrapper-video{
    margin: 120px 0 110px 0;
}
h3{
    font-weight: 400;
    font-size: 45px;
    margin-bottom: 55px;
}
h4{
    font-weight: 300;
    font-size: 30px;
}
p{
    font-weight: 300;
    font-size: 20px;
}
video{
    width: 100%;
    border-radius: 30px;
}
.highlight{
    display: inline-flex;
    transform: rotate(-90deg);
    position: absolute;
    bottom: 0;
    right: -10px;
}
.highlight .after{
    background: #DBBD6E;
    height: 1px;
    width: 50px;
    align-self: center;
    margin-left: 10px;
}
@media (max-width: 1200px){
    
}

@media (max-width: 992px){
    .highlight{
        display: none;
    }
}
@media (max-width: 768px){
    #aboutus{
        padding: 80px 15px 0 15px;
    }
    .wrapper-aboutus{
        background: #F1EBE3;
        border-radius: 50px;
        padding: 60px 30px;
    }
    .wrapper-video{
        margin: 70px 0 60px 0;
    }
    h3{
        font-size: 35px;
        margin-bottom: 45px;
    }
    h4{
        font-size: 25px;
    }
    p{
        font-weight: 300;
        font-size: 18px;
        margin-bottom: 30px;
    }
}
</style>